var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.4995C3.05087 13.4999 2.35877 13.36 1.71465 13.0882C1.07053 12.8164 0.487482 12.4181 0 11.917V17.9995C0.00178057 18.5957 0.239405 19.1669 0.660977 19.5885C1.08255 20.0101 1.65381 20.2477 2.25 20.2495H18.75C19.3462 20.2477 19.9175 20.0101 20.339 19.5885C20.7606 19.1669 20.9982 18.5957 21 17.9995V11.917C20.5125 12.4181 19.9295 12.8164 19.2853 13.0882C18.6412 13.36 17.9491 13.4999 17.25 13.4995H3.75Z",
    fill: "url(#paint0_linear_6126_18246)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.5H11.25V12H9.75V10.5Z",
    fill: "url(#paint1_linear_6126_18246)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75H15.75V3C15.75 2.40326 15.5129 1.83097 15.091 1.40901C14.669 0.987053 14.0967 0.75 13.5 0.75H7.5C6.90326 0.75 6.33097 0.987053 5.90901 1.40901C5.48705 1.83097 5.25 2.40326 5.25 3V3.75H2.25C1.65381 3.75178 1.08255 3.98941 0.660977 4.41098C0.239405 4.83255 0.00178057 5.40381 0 6V8.25C0 9.24456 0.395088 10.1984 1.09835 10.9017C1.80161 11.6049 2.75544 12 3.75 12H8.25V10.5C8.25119 10.1025 8.4096 9.7217 8.69065 9.44065C8.9717 9.1596 9.35254 9.00119 9.75 9H11.25C11.6475 9.00119 12.0283 9.1596 12.3094 9.44065C12.5904 9.7217 12.7488 10.1025 12.75 10.5V12H17.25C18.2446 12 19.1984 11.6049 19.9017 10.9017C20.6049 10.1984 21 9.24456 21 8.25V6C20.9982 5.40381 20.7606 4.83255 20.339 4.41098C19.9175 3.98941 19.3462 3.75178 18.75 3.75ZM6.75 3C6.75 2.80109 6.82902 2.61032 6.96967 2.46967C7.11032 2.32902 7.30109 2.25 7.5 2.25H13.5C13.6989 2.25 13.8897 2.32902 14.0303 2.46967C14.171 2.61032 14.25 2.80109 14.25 3V3.75H6.75V3Z",
    fill: "url(#paint2_linear_6126_18246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6126_18246",
    x1: 10.5,
    y1: 11.917,
    x2: 10.5,
    y2: 20.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6126_18246",
    x1: 10.5,
    y1: 10.5,
    x2: 10.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6126_18246",
    x1: 10.5,
    y1: 0.75,
    x2: 10.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.a82c79d85842fe69d229f5bef310d642.svg";
export { ForwardRef as ReactComponent };